function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M.498 0h239.004v240H.498z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M138.389 17.228c5.855 3.126 7.645 11.246 3.997 18.135a16.117 16.117 0 01-3.766 4.73L123.066 54l-15.004-13.893a16.114 16.114 0 01-3.784-4.744c-3.647-6.89-1.858-15.009 3.998-18.135 4.873-2.602 11.026-.926 15.057 3.68 4.03-4.606 10.183-6.282 15.056-3.68z",
  stroke: "#371447",
  strokeWidth: 3,
  fill: "#1E88E5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M200.2 142.519c8.284 0 15 6.715 15 15v42.5H31.465v-42.5c0-8.285 6.716-15 15-15H200.2zm-15.977-47.501c8.284 0 15 6.716 15 15v32.37l-.002.13H47.443l-.001-.13v-32.37c0-8.284 6.716-15 15-15h121.78z",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("g", {
  fill: "#371447"
}, /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -365.657 161.94)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -360.68 180.516)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -355.702 199.091)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -350.725 217.667)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -345.747 236.243)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -340.77 254.818)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -335.793 273.394)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -330.815 291.97)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -325.838 310.545)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -320.86 329.121)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -315.883 347.697)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -310.906 366.272)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -305.929 384.848)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -300.951 403.424)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -295.974 422)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -290.997 440.575)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -286.02 459.15)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -281.042 477.727)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
})), /*#__PURE__*/React.createElement("g", {
  transform: "rotate(30 -276.065 496.302)"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 3,
  rx: 2.988,
  ry: 3
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.988,
  cy: 11,
  rx: 1.992,
  ry: 2
}), /*#__PURE__*/React.createElement("circle", {
  cx: 2.988,
  cy: 17,
  r: 1
}))), /*#__PURE__*/React.createElement("path", {
  d: "M169.362 56.518c8.284 0 15 6.716 15 15V92.07c0 1.009-.1 1.995-.29 2.948H61.63c-.19-.953-.29-1.94-.29-2.948V71.518c0-8.284 6.716-15 15-15h93.022z",
  stroke: "#371447",
  strokeWidth: 3
}), /*#__PURE__*/React.createElement("path", {
  d: "M57.423 156.52v.008c0 11.616 9.378 21.033 20.946 21.033 11.567 0 20.945-9.417 20.945-21.02v-.022h2.988v.01c0 11.615 9.377 21.032 20.945 21.032s20.946-9.417 20.946-21.02v-.022h2.988v.01c0 11.615 9.377 21.032 20.945 21.032s20.946-9.417 20.946-21.02v-.022h2.988v.01c0 11.615 9.377 21.032 20.945 21.032.235 0 .468-.004.7-.011v3.001c-.232.007-.466.01-.7.01-10.284 0-19.054-6.514-22.44-15.657-3.385 9.143-12.154 15.657-22.439 15.657-10.284 0-19.054-6.514-22.44-15.657-3.385 9.143-12.154 15.657-22.439 15.657-10.145 0-18.817-6.34-22.3-15.289l-.14-.368-.14.368c-3.481 8.95-12.153 15.29-22.298 15.29-10.146 0-18.818-6.34-22.3-15.29l-.14-.368-.14.368c-3.482 8.95-12.154 15.29-22.3 15.29-.177 0-.353-.003-.53-.007v-3c.176.004.353.006.53.006 11.569 0 20.946-9.417 20.946-21.02v-.022h2.988zm14.375-49.001c0 9.112 7.356 16.5 16.431 16.5 9.075 0 16.432-7.388 16.432-16.487v-.013h2.987c0 9.112 7.357 16.5 16.432 16.5s16.432-7.388 16.432-16.487l-.001-.013h2.988c0 9.112 7.357 16.5 16.432 16.5s16.431-7.388 16.431-16.487v-.013h2.988c0 9.112 7.356 16.5 16.431 16.5.674 0 1.338-.041 1.99-.12v3.018c-.654.067-1.318.102-1.99.102-8.073 0-14.996-4.948-17.925-11.988-2.93 7.04-9.852 11.988-17.925 11.988-8.074 0-14.997-4.948-17.926-11.988-2.929 7.04-9.851 11.988-17.925 11.988s-14.996-4.948-17.926-11.988c-2.928 7.04-9.851 11.988-17.925 11.988-8.073 0-14.996-4.948-17.925-11.988-2.929 7.04-9.852 11.988-17.925 11.988-1.19 0-2.356-.108-3.487-.314v-3.059a16.43 16.43 0 003.487.373c9.075 0 16.431-7.388 16.431-16.487v-.013h2.988zm10.627-41.018v.006l.003.277c.15 7.06 5.898 12.717 12.943 12.717s12.793-5.658 12.943-12.702l.003-.266v-.032h2.987v.006l.003.277c.15 7.06 5.899 12.717 12.944 12.717 7.032 0 12.774-5.638 12.942-12.666l.004-.315h2.987l.003.264c.15 7.06 5.898 12.717 12.943 12.717s12.793-5.658 12.943-12.702l.003-.266v-.032h2.988v.006l.003.277c.15 7.06 5.898 12.717 12.943 12.717.291 0 .58-.01.868-.03v3.006c-.288.016-.577.024-.868.024-6.38 0-11.897-3.77-14.44-9.23-2.54 5.457-8.057 9.23-14.44 9.23-6.38 0-11.896-3.77-14.438-9.229l-.145.301c-2.602 5.295-8.033 8.928-14.296 8.928-6.381 0-11.897-3.77-14.44-9.23-2.54 5.457-8.057 9.23-14.44 9.23-6.38 0-11.897-3.77-14.44-9.23-2.54 5.457-8.057 9.23-14.44 9.23-1.262 0-2.49-.148-3.667-.426v-3.103a12.9 12.9 0 003.667.529c7.045 0 12.793-5.658 12.943-12.702l.003-.266v-.032h2.988z",
  fill: "#371447",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("g", {
  transform: "translate(52.876 181.603)",
  fill: "#1E88E5"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 3.194,
  cy: 3.207,
  rx: 3.194,
  ry: 3.207
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 93.816,
  cy: 3.207,
  rx: 3.194,
  ry: 3.207
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 48.505,
  cy: 3.207,
  rx: 3.194,
  ry: 3.207
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 139.127,
  cy: 3.207,
  rx: 3.194,
  ry: 3.207
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 -1 67.813 132.519)",
  fill: "#1E88E5"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.509,
  cy: 2.52,
  rx: 2.509,
  ry: 2.52
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 73.713,
  cy: 2.52,
  rx: 2.509,
  ry: 2.52
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 38.111,
  cy: 2.52,
  rx: 2.509,
  ry: 2.52
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 109.314,
  cy: 2.52,
  rx: 2.509,
  ry: 2.52
})), /*#__PURE__*/React.createElement("g", {
  transform: "matrix(1 0 0 -1 78.768 87.543)",
  fill: "#1E88E5"
}, /*#__PURE__*/React.createElement("ellipse", {
  cx: 2.091,
  cy: 2.1,
  rx: 2.091,
  ry: 2.1
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 60.099,
  cy: 2.1,
  rx: 2.091,
  ry: 2.1
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 31.095,
  cy: 2.1,
  rx: 2.091,
  ry: 2.1
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 89.104,
  cy: 2.1,
  rx: 2.091,
  ry: 2.1
})));

function SvgWeddingXl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 240,
    height: 240,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgWeddingXl;